module.exports = __webpack_public_path__ + "img/HCZ4.66de9e19.jpg";